import { getCallingCardService } from "@ntconnect/framework/pbx";

export const fetchPins = (domain, page, pageSize, search, filter) =>
  getCallingCardService().fetchPins(domain, page, pageSize, search, filter);

export const fetchCdrs = (page, pageSize, search, filter) =>
  getCallingCardService().fetchCdrs(page, pageSize, search, filter);

export const createPin = (params) =>
  getCallingCardService().createPin(params);

export const deletePin = (id) =>
  getCallingCardService().deletePin(id);

export const updatePin = (id, params) =>
  getCallingCardService().updatePin(id, params);

export const resetPin = (date = null, list = null) =>
  getCallingCardService().resetPin(date, list);

export const fetchReportSchedules = (page, pageSize, search, filter) =>
  getCallingCardService().fetchReportSchedules(page, pageSize, search, filter);

export const updateReportSchedule = (id, params) =>
  getCallingCardService().updateReportSchedule(id, params);

export const fetchTariffs = (type, page = 1, pageSize = 25) =>
  getCallingCardService().fetchTariffs(type, page, pageSize);

export const fetchCallingRates = (tariff, page = 1, pageSize = 25, search, filter) =>
  getCallingCardService().fetchCallingRates(tariff, page, pageSize, search, filter);

export const createCallingRate = (tariff, params) =>
  getCallingCardService().createCallingRate(tariff, params);

export const updateCallingRate = (id, tariff, params) =>
  getCallingCardService().updateCallingRate(id, tariff, params);

export const fetchAutoGeneratedPin = (type) =>
  getCallingCardService().fetchAutoGeneratedPin(type);

export const fetchLocalTimezone = () =>
  getCallingCardService().fetchLocalTimezone();
